export default "__VITE_ASSET__hNn0Sou5__"